// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarEstimacaoVolatilidade,
  getEstimacaoVolatilidadeSelecionada,
  getEstimacaoVolatilidade,
} from "../../../../state";

export default function SelecaoEstimacaoVolatilidade() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={
          "configuracaoRelatorio.volatilidade.estimacao"
        }
        itensSelector={getEstimacaoVolatilidade}
        selectorItemSelecionado={getEstimacaoVolatilidadeSelecionada}
        onItemChange={selecionarEstimacaoVolatilidade}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
      />
    </div>
  );
}
